module.exports = __webpack_public_path__ + "static/media/collapse.6cbf9759.svg";